import { useEffect, useState } from "react";
import { SWRConfig, useSWRConfig } from "swr";
import { useRouter } from "next/router";
import classNames from "classnames";
import find from "lodash/find";
import get from "lodash/get";
import sortBy from "lodash/sortBy";
import { NextSeo } from "next-seo";

import { centraPostWithAuthAndCache } from "../lib/centra-api";
import {
  getStoryblokDataSources,
  getStoryblokStory,
} from "../lib/storyblok-api";
import Link from "../components/Link";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductGridItem from "../components/ProductGridItem";
import { StoryProvider } from "./[...slug]";

export default function Store(props) {
  const { fallback } = useSWRConfig();
  const router = useRouter();

  function getFilterHref(key, slug) {
    if (typeof location === "undefined") {
      const query = new URLSearchParams();
      query.set(key, slug);
      return "/store?" + query.toString();
    }

    const currentUrl = new URL(location.href);
    const nextUrl = new URL(location.pathname, location.origin);

    if (currentUrl.searchParams.get(key) === slug) {
      nextUrl.searchParams.delete(key);
    } else {
      nextUrl.searchParams.set(key, slug);
    }

    nextUrl.search = nextUrl.searchParams.toString();

    return nextUrl.href;
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(
      router.asPath.substring(router.asPath.indexOf("?"))
    );
    for (const key of urlParams.keys()) {
      if (
        key === "model" ||
        key === "frame" ||
        key === "lens" ||
        key === "collection"
      ) {
        setActiveFilter(true);
      } else {
        setActiveFilter(false);
      }
    }

    setActiveFilterMenu("");
  }, [router]);

  const modelArray = find(props.dataSources, "model")?.model || [];
  const frameColorArray =
    find(props.dataSources, "frame-color")?.["frame-color"] || [];
  const lensColorArray =
    find(props.dataSources, "lens-color")?.["lens-color"] || [];
  const collectionArray =
    find(props.dataSources, "collection")?.collection || [];

  let filterActive = false;
  const urlParams = new URLSearchParams(
    router.asPath.substring(router.asPath.indexOf("?"))
  );
  for (const key of urlParams.keys()) {
    if (
      key === "model" ||
      key === "frame" ||
      key === "lens" ||
      key === "collection"
    ) {
      filterActive = true;
    }
  }

  const [activeImage, setActiveImage] = useState("style");
  const [activeFilter, setActiveFilter] = useState(filterActive);
  const [activeFilterMenu, setActiveFilterMenu] = useState("");

  let products: CentraProductApiData[] = Object.values(fallback);

  const orderedModelsArray = [];
  modelArray.map((model) => orderedModelsArray.push(model.name));

  products = sortBy(products, function (item) {
    return orderedModelsArray.indexOf(item.product.model);
  });

  if (router.query.model) {
    products = products.filter((v) => v.product.model === router.query.model);
  }
  if (router.query.frame) {
    let frameColor = find(frameColorArray, {
      name: router.query.frame,
    });

    if (!frameColor) {
      frameColor = find(frameColorArray, {
        value: router.query.frame,
      });
    }

    frameColor = get(frameColor, "value");

    products = products.filter((v) => {
      const checkArray = frameColor.split(",").map((element) => element.trim());
      return checkArray.includes(v.product.frame_color);
    });
  }

  if (router.query.lens) {
    let lensColor = find(lensColorArray, {
      name: router.query.lens,
    });

    if (!lensColor) {
      lensColor = find(lensColorArray, {
        value: router.query.lens,
      });
    }

    lensColor = get(lensColor, "value");

    products = products.filter((v) => {
      const checkArray = lensColor.split(",").map((element) => element.trim());
      return checkArray.includes(v.product.lens_color);
    });
  }

  if (router.query.collection) {
    let collection = find(collectionArray, {
      name: router.query.collection,
    });

    if (!collection) {
      collection = find(collectionArray, {
        value: router.query.collection,
      });
    }

    collection = get(collection, "value");

    products = products.filter((v) => {
      let foundCategory = false;
      const checkArray = collection.split(",").map((element) => element.trim());
      v.product.categories.map((category) => {
        if (!foundCategory && checkArray.includes(category.uri)) {
          foundCategory = true;
        }
      });
      return foundCategory;
    });
  }

  if (router.query.sort === "availability") {
    products = [
      ...products.filter((v) => v.product.available),
      ...products.filter((v) => !v.product.available),
    ];
  }
  if (router.query.sort === "popularity") {
    const popular = products.filter((d) =>
      d.product.categories.some((c) => c.uri === "popular")
    );
    products = [...popular, ...products.filter((p) => !popular.includes(p))];
  }

  const productIds = products.map((v) => v.product.product);

  const filterIsActive =
    router.query.model ||
    router.query.frame ||
    router.query.lens ||
    router.query.collection;

  const content = (
    <div className="Grid">
      <div className="Grid-filters">
        <ul className="Grid-filtersGroupSelect">
          <li>
            <a
              onClick={() =>
                setActiveFilterMenu(activeFilterMenu === "view" ? "" : "view")
              }
            >
              見る<span>&times;</span>
            </a>
          </li>
          <li
            className={classNames({
              "is-selected": activeFilter,
            })}
          >
            <a
              onClick={() => {
                setActiveFilterMenu(
                  activeFilterMenu === "filter" ? "" : "filter"
                );
              }}
            >
              {/* Filter */}
              フィルター<span>&times;</span>
            </a>
          </li>
          <li
            className={classNames({
              "is-selected": activeFilterMenu,
            })}
          >
            <a
              onClick={() => {
                setActiveFilterMenu(activeFilterMenu === "sort" ? "" : "sort");
              }}
            >
              {/* Sort */}
              ソート<span>&times;</span>
            </a>
          </li>
        </ul>
        <div
          className={classNames(
            "Grid-filtersGroup Grid-filtersGroup--view u-richText",
            { "is-active": activeFilterMenu === "view" }
          )}
        >
          <h3>
            {/* View */}
            見る
          </h3>
          <ul>
            <li
              className={classNames({
                "is-active": activeImage === "style",
              })}
            >
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  setActiveImage("style");
                  setActiveFilterMenu("");
                }}
              >
                {/* Standard */}
                スタンダード
              </a>
            </li>

            <li
              className={classNames({
                "is-active": activeImage === "overview",
              })}
            >
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  setActiveImage("overview");
                  setActiveFilterMenu("");
                }}
              >
                {/* Lookbook */}
                ルックブック
              </a>
            </li>
          </ul>
        </div>
        <div
          className={classNames(
            "Grid-filtersGroup Grid-filtersGroup--filters u-richText",
            { "is-active": activeFilterMenu === "filter" }
          )}
        >
          <div className="Grid-filtersGroupSection">
            <h3>
              {/* Model */}
              モデル
            </h3>
            <ul>
              {modelArray.map((m) => {
                return (
                  <li
                    className={classNames({
                      "is-active": router.query.model === m.value,
                    })}
                    key={m.name}
                  >
                    <Link href={getFilterHref("model", m.value)} shallow>
                      {m.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="Grid-filtersGroupSection">
            <h3>
              {/* Frame color */}
              フレームカラー
            </h3>
            <ul>
              {frameColorArray.map((m) => {
                const fColorArray = m.value.split(",");

                if (fColorArray.length === 1) {
                  return (
                    <li
                      className={classNames({
                        "is-active": router.query.frame === m.value,
                      })}
                      key={m.name}
                    >
                      <Link href={getFilterHref("frame", m.value)} shallow>
                        {m.name.trim()}
                      </Link>
                    </li>
                  );
                } else {
                  return (
                    <li
                      className={classNames({
                        "is-active": router.query.frame === m.name,
                      })}
                      key={m.name}
                    >
                      <Link href={getFilterHref("frame", m.name)} shallow>
                        {m.name.trim()}
                      </Link>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
          <div className="Grid-filtersGroupSection">
            <h3>
              {/* Lens color */}
              レンズカラー
            </h3>
            <ul>
              {lensColorArray.map((m) => {
                let label = m.name;
                label = label.trim();

                return (
                  <li
                    className={classNames({
                      "is-active": router.query.lens === m.value,
                    })}
                    key={m.name}
                  >
                    <Link href={getFilterHref("lens", m.value)} shallow>
                      {label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="Grid-filtersGroupSection">
            <h3>
              {/* Collection */}
              コレクション
            </h3>
            <ul>
              {collectionArray.map((m) => (
                <li
                  className={classNames({
                    "is-active": router.query.collection === m.name,
                  })}
                  key={m.name}
                >
                  <Link href={getFilterHref("collection", m.name)} shallow>
                    {m.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div
          className={classNames(
            "Grid-filtersGroup Grid-filtersGroup--sort u-richText",
            { "is-active": activeFilterMenu === "sort" }
          )}
        >
          <h3>
            {/* Sort */}
            ソート
          </h3>
          <ul>
            <li
              className={classNames({
                "is-active": !router.query.sort,
              })}
            >
              <Link href="/store" shallow>
                {/* Model */}
                モデル
              </Link>
            </li>

            <li
              className={classNames({
                "is-active": router.query.sort === "availability",
              })}
            >
              <Link href={getFilterHref("sort", "availability")} shallow>
                {/* Availability */}
                在庫状況
              </Link>
            </li>

            <li
              className={classNames({
                "is-active": router.query.sort === "popularity",
              })}
            >
              <Link href={getFilterHref("sort", "popularity")} shallow>
                {/* Popularity */}
                人気順
              </Link>
            </li>
          </ul>
        </div>
        <div className="Grid-filtersGroup u-richText">
          {filterIsActive ? (
            <p>
              <Link className="clear" href="/store">
                {/* Clear filter */}
                フィルターを削除する
              </Link>
            </p>
          ) : null}
        </div>
      </div>

      {productIds.map((id) => (
        <ProductGridItem
          productId={id}
          key={id}
          reverseImages={activeImage === "overview"}
        />
      ))}
    </div>
  );

  return (
    <StoryProvider {...props}>
      <NextSeo
        title="Store – Monokel Eyewear"
        openGraph={{
          url: "https://monokel-eyewear.com/store",
          title: "Store – Monokel Eyewear",
        }}
      />

      <Header />

      <SWRConfig
        value={{
          revalidateOnMount: false,
        }}
      >
        {content}
      </SWRConfig>

      <Footer />
    </StoryProvider>
  );
}

export async function getStaticProps({ preview }) {
  const isWorkingInStoryblok = process.env.NODE_ENV !== "production" || preview;

  const centraRes = centraPostWithAuthAndCache(
    "https://monokel.centra.com/api/checkout/products/",
    "none",
    {
      market: "6",
    }
  );

  const mainMenuRes = getStoryblokStory("main-menu", {
    version: isWorkingInStoryblok ? "draft" : "published",
  });

  const dataSourcesRes = getStoryblokDataSources();

  try {
    // eslint-disable-next-line no-var
    var [centraData, mainMenu, dataSources] = await Promise.all([
      centraRes,
      mainMenuRes,
      dataSourcesRes,
    ]);
  } catch (error) {
    console.error(error);

    return {
      notFound: true,
    };
  }

  if (centraData?.productCount) {
    const productIds = sortBy(
      centraData.products.map((p) => p.product),
      ["product.model", "product.name"]
    );

    const swrFallback = centraData.products.reduce((result, p) => {
      const url = `https://monokel.centra.com/api/checkout/products/${p.product}`;
      result[url] = { product: p };

      return result;
    }, {});

    return {
      revalidate: 60,
      props: {
        dataSources,
        productIds,
        mainMenu,
        swrFallback,
      },
    };
  }
}
